import React from 'react';

export default function FoodIntakeTemplateItemMenuPanel({ onEdit, onDelete, onCancel }) {
  return (
    <div style={{
      background: '#fff',
      borderRadius: 12,
      padding: 24,
      minWidth: 180,
      boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      zIndex: 20000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 12
    }}>
      <button
        onClick={onEdit}
        style={{
          padding: '10px 0',
          fontSize: '1.05rem',
          fontWeight: 600,
          borderRadius: 8,
          border: '1px solid #6cf',
          background: '#eaf6ff',
          color: '#227',
          cursor: 'pointer'
        }}
      >Edit</button>

      <button
        onClick={onDelete}
        style={{
          padding: '10px 0',
          fontSize: '1.05rem',
          fontWeight: 600,
          borderRadius: 8,
          border: '1px solid #f66',
          background: '#fff0f0',
          color: '#a22',
          cursor: 'pointer'
        }}
      >Delete</button>

      <button
        onClick={onCancel}
        style={{
          padding: '10px 0',
          fontSize: '1.05rem',
          fontWeight: 600,
          borderRadius: 8,
          border: '1px solid #bbb',
          background: '#f8f8f8',
          color: '#555',
          cursor: 'pointer'
        }}
      >Cancel</button>
    </div>
  );
}
